import React from "react";
import ProviderInput from "./ProviderInput";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import { ReactComponent as AddIcon } from "../../../../assets/icons/add.svg";

const emptyContact = {
  countryCode: "+44",
  number: "",
};

const MultiContactList = ({
  label = "Contact",
  contacts = [emptyContact],
  onChange,
}) => {
  const safeContacts = contacts?.length ? contacts : [emptyContact];

  const updateContact = (contactIndex, field, value) => {
    const updatedContacts = safeContacts.map((contact, index) =>
      index === contactIndex
        ? {
            ...contact,
            [field]: value,
          }
        : contact,
    );

    onChange(updatedContacts);
  };

  const addContact = () => {
    onChange([...safeContacts, { ...emptyContact }]);
  };

  const removeContact = (contactIndex) => {
    const updatedContacts = safeContacts.filter(
      (_, index) => index !== contactIndex,
    );

    onChange(updatedContacts.length ? updatedContacts : [{ ...emptyContact }]);
  };

  return (
    <div className="provider-network-multi-field">
      <div className="provider-network-multi-field-header">
        <label className="provider-network-label">{label}</label>

        <AddIcon className="provider-network-add-icon" onClick={addContact} />
        {/* <button
          type="button"
          className="provider-network-add-row-btn"
          onClick={addContact}
        >
        </button> */}
      </div>

      <div className="provider-network-multi-field-list">
        {safeContacts.map((contact, contactIndex) => (
          <div
            key={`contact-${contactIndex}`}
            className="provider-network-multi-field-row"
          >
            <div className="provider-network-phone-row">
              <ProviderInput
                type="select"
                value={contact.countryCode || "+44"}
                onChange={(value) =>
                  updateContact(contactIndex, "countryCode", value)
                }
                options={[{ value: "+44", label: "UK (+44)" }]}
                className="provider-network-no-margin"
              />

              <ProviderInput
                value={contact.number || ""}
                placeholder="Telephone Number"
                onChange={(value) =>
                  updateContact(contactIndex, "number", value)
                }
                className="provider-network-no-margin"
              />
            </div>

            <button
              type="button"
              className="provider-network-row-delete-btn"
              onClick={() => removeContact(contactIndex)}
              disabled={
                safeContacts.length === 1 &&
                !contact.number &&
                contact.countryCode === "+44"
              }
              title="Delete contact"
              aria-label="Delete contact"
            >
              <DeleteIcon />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultiContactList;
